import { ESortOder, ESortTypes } from 'reactApp/modules/sort/sort.types';
import { Order, Sort as QuotaSort } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import { Sort } from 'reactApp/types/Tree';

const getSort = (sort: ESortTypes | null | undefined): QuotaSort => {
    switch (sort) {
        case ESortTypes.mtime:
            return QuotaSort.date;
        case ESortTypes.size:
            return QuotaSort.size;
        default:
            return QuotaSort.name;
    }
};

const getOrder = (order: ESortOder | undefined): Order => (order === ESortOder.desc ? Order.desc : Order.asc);

export const getSortParams = (params?: Sort): { sort: QuotaSort; order: Order } => {
    const { type, order } = params ?? {};

    return {
        sort: getSort(type),
        order: getOrder(order),
    };
};
